import {clinicSqbQueryResult, getMedicalOrderDetail, listMedicalOrder, getDicts, getPatientListByName} from "@/api";
import {addDateRange, message} from "@/assets/utils/common";
import baseConfig from "@/api/config";
import html2canvas from 'html2canvas'
import Orderdetail from "@/components/orderdetail.vue";

// 开方日期默认含今天在内的近7个自然日，使用本地日期避免时区偏移。
function getDefaultOrderDateRange() {
    const endDate = new Date();
    const startDate = new Date(endDate);
    startDate.setDate(startDate.getDate() - 6);
    const formatDate = date => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };
    return [formatDate(startDate), formatDate(endDate)];
}

export default {
    components: {Orderdetail},
    data() {
        return {
            currentPageOrder: 1,
            pageNumsOrder: 20,
            nameSelectConShow: false,
            patientRange: [],
            queryOrderParams: {
                serialNo: '',
                status: '3',
                billingType: '',
                identity: '',
                phoneNumber: '',
                doctorName: '',
                patientName: '',
                params: null
            },
            totalCountOrder: 0,
            orderTableLoading: false,
            orderListRequestId: 0,
            lastFocusRefreshTime: 0,
            pendingOrderCount: null,
            dateTime: getDefaultOrderDateRange(),
            dateOrderTime: '',
            orderTableHeight: 500,
            tencentCosUrl: baseConfig.tencentCosUrl,
            patientInfo: {
                avatarImg: null,
                name: null,
                sex: null,
                age: null,
                phoneNumber: null,
                identity: null,
                province: null,
                dppId: null,
                height: null,
                weight: null,
                casePic: null,
                operationHistory: null,
                medicalHistory: null
            },
            orderlist: [],
            listQuerying: false, // 列表行「查询收款结果」进行中
            patientId: null,
            direction: 'rtl',
            orderDetailDialogVisible: false,

            listPrintOrderId: null,
            listPrintKey: 0,
            listPaymentOrderId: null,
            listPaymentKey: 0,
            orderId: null,
            orderWarningInfo: null,
            fileLists: [],
            imageStyles: {
                width: 90,
                height: 120,
            },
            medicalOrder: {
                orderSource: null,
                status: null,
                serialNo: null,
                medicineType: null,
                picUrl: null,
                orderWeight: null,
                payQrcode: null,
                createTime: null,
                updateTime: null,
                pharmacyName: null,
                pharmacistName: null,
                remark: null,
                pharmacyAddress: null,
                clinicalDiagnosis: null,
                orderMedicineList: [],
                orderMedicineFuList: [],
                instructions: null,
                orderPrice: 0,
                payTime: null,
                viceNum: 0,
                deliverTime: null,
                freeCasePic: null,
                processingCosts: null,
            },
            showOrderMedicineFuList: "", // 辅料药材信息
            dictOrderStatus:'sys_order_status',
            dictOrderStatusList:[],
            doctorInfo: {
                name: null,
                signPic: null,
                phoneNumber: null,
                docPriceHide: 0, // 诊费 0 显示  1 隐藏
            },
            prescriptionPaperDialogDialogVisible: false, // 处方笺预览弹窗
            printDate: null, // 打印日期
        }
    },
    mounted() {
        window.addEventListener('focus', this.handleOrderPageFocus);
        document.addEventListener('visibilitychange', this.handleOrderPageVisibility);
        //此处需要通过延迟方法来设置值，不然会出现值已更新，但页面没更新的问题
        setTimeout(() => {
            this.orderTableHeight = window.innerHeight - this.$refs.multipleOrderTable.$el.offsetTop - 80;
        }, 100)
    },
    created() {
        // 恢复本标签页手动选择的日期；刷新页面不能覆盖操作员的筛选范围。
        try {
            const savedRange = sessionStorage.getItem('clinicFee.order.prescriptionDateRange');
            if (savedRange !== null) {
                const range = JSON.parse(savedRange);
                if (range === null || (Array.isArray(range) && (range.length === 0 ||
                    (range.length === 2 && range.every(value => typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)))))) {
                    this.dateTime = range;
                }
            }
        } catch (error) {
            console.warn('恢复开方日期筛选失败，使用当前日期条件。', error);
        }
        // 首次加载前同步日期条件，订单列表和待支付数量使用相同的查询范围。
        addDateRange(this.queryOrderParams, this.dateTime);
        getDicts(this.dictOrderStatus).then(res => {
            this.dictOrderStatusList  = res.data.data;
        });
        this.getOrderList();
    },
    beforeUnmount() {
        window.removeEventListener('focus', this.handleOrderPageFocus);
        document.removeEventListener('visibilitychange', this.handleOrderPageVisibility);
        this.orderListRequestId++;
    },
    methods: {
        // 页面恢复可见与获得焦点可能同时触发，一秒内合并重复事件。
        handleOrderPageFocus() {
            if (document.hidden || Date.now() - (this.lastFocusRefreshTime || 0) < 1000) return;
            this.lastFocusRefreshTime = Date.now();
            this.refreshOrderListSilently();
        },
        handleOrderPageVisibility() {
            if (!document.hidden) this.handleOrderPageFocus();
        },
        // 仅对列表展示脱敏，保留原始号码供查询、详情和收费使用；异常短值全部隐藏。
        maskOrderPhone(value) {
            const phone = value === null || value === undefined ? '' : String(value).trim();
            if (!phone) return '---';
            return /^\d{11}$/.test(phone) ? phone.slice(0, 3) + '****' + phone.slice(-4) : '****';
        },
        maskOrderIdentity(value) {
            const identity = value === null || value === undefined ? '' : String(value).trim();
            if (!identity) return '---';
            return /^(\d{15}|\d{17}[\dXx])$/.test(identity)
                ? identity.slice(0, 6) + '*'.repeat(identity.length - 10) + identity.slice(-4) : '****';
        },
        // 列表金额与重量统一保留两位小数，单位仅在表头展示，不修改原始值。
        formatOrderListNumber(value) {
            if (value === null || value === undefined || value === '') return '0.00';
            const number = Number(value);
            return Number.isFinite(number) ? number.toFixed(2) : '--';
        },

        changeData(name) {
            this.$router.push({path: '/admin/' + name});
            this.$store.state.adminleftnavnum = name; //设置左侧导航2-2 active
        },

        // chooseDateTime
        chooseDateTime() {
            addDateRange(this.queryOrderParams, this.dateTime);
            // 清空日期也属于用户选择，不能在下次刷新时重置为近7天。
            try {
                sessionStorage.setItem('clinicFee.order.prescriptionDateRange', JSON.stringify(this.dateTime || null));
            } catch (error) {
                console.warn('保存开方日期筛选失败。', error);
            }
        },

        // 切换分页
        handleOrderCurrentChange: function (val) {
            this.currentPageOrder = val;
            this.getOrderList();
        },

        // 切换分页
        handleOrderSizeChange: function (val) {
            this.pageNumsOrder = val;
            this.getOrderList();
        },

        /** 重置按钮操作 */
        resetQuery() {
            // 重置其他查询项时保留已选开方日期，日期仅由日期控件变更。
            this.queryOrderParams = {
                serialNo: '',
                status: '3',
                billingType: '',
                identity: '',
                phoneNumber: '',
                patientName: '',
                params: null
            };
            addDateRange(this.queryOrderParams, this.dateTime);
            this.getOrderList();
        },

        // 只有服务端确认的多方批次参与配色，绝不以患者姓名或日期推断同批。
        assignPrescriptionGroupColors(rows) {
            const eligibleRows = rows.filter(row => row.prescriptionGroupId &&
                Number(row.prescriptionGroupCount) > 1 && Number(row.prescriptionGroupWaitPayCount) > 0);
            const getPatientKey = row => row.patientId === null || row.patientId === undefined || row.patientId === ''
                ? `group:${row.prescriptionGroupId}` : `patient:${row.patientId}`;
            // 排序后分配使同页数据调整顺序时颜色不变；患者缺失时退回真实批次号。
            const patientKeys = [...new Set(eligibleRows.map(getPatientKey))].sort();
            const colorIndexes = new Map(patientKeys.map((key, index) => [key, index]));
            const batchColorIndexes = new Map(eligibleRows.map(row =>
                [String(row.prescriptionGroupId), colorIndexes.get(getPatientKey(row))]));
            rows.forEach(row => {
                row.patientGroupColorIndex = eligibleRows.includes(row)
                    ? batchColorIndexes.get(String(row.prescriptionGroupId)) : null;
            });
        },

        getOrderRowClassName({row}) {
            return Number.isInteger(row.patientGroupColorIndex) ? 'prescription-group-pending' : '';
        },

        getOrderRowStyle({row}) {
            if (!Number.isInteger(row.patientGroupColorIndex)) return {};
            // 黄金角拉开相邻患者的色相；统一饱和度和明度，避免整表出现浓重色块。
            const hue = (210 + row.patientGroupColorIndex * 137.508) % 360;
            return {
                '--prescription-group-bg': `hsl(${hue}, 55%, 96%)`,
                '--prescription-group-hover': `hsl(${hue}, 55%, 92%)`,
                '--prescription-group-accent': `hsl(${hue}, 38%, 60%)`
            };
        },

        // 收费后的后台刷新保留现有列表，不闪白、不显示整表遮罩。
        refreshOrderListSilently() {
            return this.getOrderList({silent: true});
        },

        // 查询订单列表；仅业务事件触发的刷新使用静默模式。
        getOrderList(options = {}) {
            const silent = options.silent === true;
            const requestId = ++this.orderListRequestId;
            if (!silent) {
                this.orderlist = [];
                this.orderTableLoading = true;
                this.pendingOrderCount = null;
            }
            const pendingQueryParams = Object.assign({}, this.queryOrderParams, {
                status: '3',
                pageNum: 1,
                pageSize: 1
            });
            listMedicalOrder(pendingQueryParams).then(response => {
                if (requestId !== this.orderListRequestId) return;
                this.pendingOrderCount = response.data.code === 200 ? Number(response.data.total) || 0 : null;
            }).catch(() => {
                if (requestId === this.orderListRequestId) this.pendingOrderCount = null;
            });
            //根据工单类型筛选，已完成订单
            this.queryOrderParams.pageNum = this.currentPageOrder;
            this.queryOrderParams.pageSize = this.pageNumsOrder;
            return listMedicalOrder(this.queryOrderParams).then(response => {
                if (requestId !== this.orderListRequestId) return;
                // console.log(response);
                this.orderTableLoading = false;
                if (response.data.code === 200) {
                    this.totalCountOrder = response.data.total;
                    if (response.data.total > 0) {
                        this.orderlist = response.data.rows;
                        this.orderlist.forEach((medicalOrder) => {
                            medicalOrder.prescriptionGroupCount = Number(medicalOrder.prescriptionGroupCount) || 0;
                            medicalOrder.prescriptionGroupWaitPayCount = Number(medicalOrder.prescriptionGroupWaitPayCount) || 0;
                            if (medicalOrder.patientSex === '0') {
                                medicalOrder.patientSexText = '男';
                                medicalOrder.patientAvatar = this.tencentCosUrl + "/tcmmsPic/manImg.png";
                            } else if (medicalOrder.patientSex === '1') {
                                medicalOrder.patientSexText = '女';
                                medicalOrder.patientAvatar = this.tencentCosUrl + "/tcmmsPic/womanImg.png";
                            } else {
                                medicalOrder.patientSexText = '未知';
                                medicalOrder.patientAvatar = this.tencentCosUrl + "/tcmmsPic/profile.jpg";
                            }

                            if (medicalOrder.billingType === "0") {
                                medicalOrder.billingTypeName = "颗粒";
                            } else if (medicalOrder.billingType === "1") {
                                medicalOrder.billingTypeName = "饮片";
                            } else if (medicalOrder.billingType === "2") {
                                medicalOrder.billingTypeName = "膏方";
                            } else if (medicalOrder.billingType === "3") {
                                medicalOrder.billingTypeName = "水丸";
                            }

                            medicalOrder.showOrderMedicineInfo = "";
                            if (medicalOrder.orderMedicineList !== null && medicalOrder.orderMedicineList.length > 0) {
                                medicalOrder.orderMedicineList.forEach((med) => {
                                    let meName = med.meName;
                                    if (meName !== null && meName !== undefined) {
                                        meName = meName.replace('配方', '').replace('颗粒', '').replace('饮片', '');
                                    }
                                    med.meName = meName;
                                    medicalOrder.showOrderMedicineInfo += med.meName + "" + med.countNum + "g,";
                                });
                            }
                            if (medicalOrder.orderMedicineFuList !== null && medicalOrder.orderMedicineFuList.length > 0) {
                                medicalOrder.showOrderMedicineInfo += "辅药(";
                                medicalOrder.orderMedicineFuList.forEach((med) => {
                                    let meName = med.meName;
                                    if (meName !== null && meName !== undefined && meName.length > 0) {
                                        meName = meName.replace('配方', '').replace('颗粒', '').replace('饮片', '');
                                    }
                                    med.meName = meName;
                                    medicalOrder.showOrderMedicineInfo += med.meName + "" + med.countNum + "g,";
                                });
                                medicalOrder.showOrderMedicineInfo = medicalOrder.showOrderMedicineInfo.substring(0, medicalOrder.showOrderMedicineInfo.length - 1);
                                medicalOrder.showOrderMedicineInfo += ')';
                            } else {
                                medicalOrder.showOrderMedicineInfo = medicalOrder.showOrderMedicineInfo.substring(0, medicalOrder.showOrderMedicineInfo.length - 1);
                            }
                        });
                        this.assignPrescriptionGroupColors(this.orderlist);
                    } else {
                        this.orderlist = [];
                    }
                } else if (!silent) {
                    this.totalCountOrder = 0;
                    message('订单查询失败，请稍后重试。', 'error');
                }
            }).catch(() => {
                if (requestId !== this.orderListRequestId || silent) return;
                this.totalCountOrder = 0;
                message('订单查询失败或超时，请稍后重试；请勿重复收费。', 'error');
            }).finally(() => {
                // 旧请求结束不能关闭新请求的加载状态。
                if (requestId === this.orderListRequestId) this.orderTableLoading = false;
            });
        },

        // 扫码枪将订单条码作为键盘输入并以 Enter 结束；唯一订单自动打开详情
        searchOrderByBarcode() {
            const serialNo = (this.queryOrderParams.serialNo || '').trim();
            if (!serialNo) {
                return;
            }
            this.queryOrderParams.serialNo = serialNo;
            this.queryOrderParams.status = '';
            this.currentPageOrder = 1;
            this.getOrderList().then(() => {
                if (this.orderlist.length === 0) {
                    message("未查询到对应订单", "warning");
                } else if (this.orderlist.length === 1) {
                    this.openOrderDetail(this.orderlist[0].orderId, this.orderlist[0].status);
                } else {
                    message("查询到多笔订单，请在列表中确认后打开", "warning");
                }
            }).catch(() => {
                message("订单查询失败，请重试", "error");
            });
        },

        // 通过患者姓名获取患者列表
        queryPatiantListByName(queryName) {
            if (queryName !== "" && queryName !== null && queryName !== undefined) {
                this.queryOrderParams.patientName = queryName;
                getPatientListByName(queryName).then(response => {
                    this.patientInfoList = [];
                    this.patientRange = [];
                    if (response.data.code === 200) {
                        this.patientInfoList = response.data.rows;
                        if (this.patientInfoList.length > 0) {
                            this.nameSelectConShow = true;
                            this.patientInfoList.forEach(item => {
                                this.patientRange.push({
                                    dppId: item.dppId,
                                    name: item.name,
                                    sex: item.sex === '0'?'男':item.sex === '1'?'女':'未知',
                                    age: item.age,
                                    identity: item.identity,
                                    isChoose: false,
                                });
                            })
                        } else {
                            this.nameSelectConShow = false;
                        }
                    } else {
                        this.nameSelectConShow = false;
                    }
                });
            } else {
                this.nameSelectConShow = false;
                this.patientInfo.dppId = null;
                this.currentPageOrder = 1;
                this.getOrderList();
            }
        },

        // 确定选择患者
        sureChoosePatient(dppId, patientName) {
            this.patientInfo.dppId = dppId;
            this.queryOrderParams.patientName = patientName;
            this.patientRange.forEach(itm=>{
                itm.isChoose = dppId === itm.dppId;
            })
            this.nameSelectConShow = false;
            this.currentPageOrder = 1;
            this.getOrderList();
        },

        closeNameSelectConShow() {
            this.nameSelectConShow = false;
        },


        // 列表行「查询收款结果」：弹窗关闭后仍可从这里补查。只读查单，绝不发起扣款。
        // autoPoll 传 false：后端据此把留痕记成 manual（只有弹窗自动轮询才传 true）。
        queryListPayResult(row) {
            if (this.listQuerying) {
                return;
            }
            this.listQuerying = true;
            clinicSqbQueryResult(row.orderId, false).then(response => {
                const payload = (response && response.data && response.data.code !== undefined) ? response.data : response;
                const data = (payload && payload.data) || {};
                if (payload && payload.code === 200 && data.payState === 'success') {
                    message("该订单已通过收钱吧支付", "success");
                    this.getOrderList();
                } else if (payload && payload.code === 601 && data.payState === 'pending') {
                    //601 是正常业务态，绝不能报 error —— 报错会诱导收银员重扫
                    message("收款结果仍未确认，请稍后再查", "warning");
                } else {
                    //含「该订单尚未发起过扫码支付，无法查询支付结果」，原样透出后端文案
                    message((payload && payload.msg) || "查询收款结果失败", "error");
                }
            }).catch(error => {
                console.error('查询收款结果失败:', error);
                message("查询收款结果失败，请稍后重试", "error");
            }).finally(() => {
                this.listQuerying = false;
            });
        },

        getOrderStatus(dictCode){
            return this.getDictValue(dictCode,this.dictOrderStatusList);
        },

        getDictValue(dictKey, dictList) {
            let str = '';
            dictList.forEach(e => {
                if (e.dictValue == dictKey) {
                    str = e.dictLabel;
                }
            })
            return str;
        },
        // 列表打印仅复用凭证逻辑，不触发收费或修改订单状态。
        printListReceipt(row) {
            this.listPrintOrderId = row.orderId;
            this.listPrintKey++;
        },

        // 直接复用收费组件，独立于详情抽屉，避免多一层操作。
        openListPayment(row) {
            if (row.status !== '3') return;
            this.listPaymentOrderId = row.orderId;
            this.listPaymentKey++;
        },

        // 打开订单详情
        dbclickOpenOrderDetail(row) {
            let orderId = row.orderId;
            let status = row.status;
            this.openOrderDetail(orderId, status);
        },

        // 打开订单详情
        openOrderDetail(orderId, status) {
            this.orderId = orderId;
            if (status === '1') {
                message("药方审核中，请耐心等待...", "error");
            } else if (status === '2') {
                message("药方转方中，请耐心等待...", "error");
            } else {
                this.orderDetailDialogVisible = true;
                this.queryOrderDetail();
                // this.$router.push({path: '/admin/detail', query: { orderId: orderId }});
                // this.$store.state.adminleftnavnum = 'detail'; //设置左侧导航2-2 active
            }
        },


        // 查询订单详情
        queryOrderDetail() {
            getMedicalOrderDetail(this.orderId).then(response => {
                console.log("getMedicalOrderDetailInfo response");
                console.log(response);
                let rdata = response.data.data;
                this.medicalOrder = rdata.medicalOrder;
                this.medicalOrder.orderPrice = parseFloat(rdata.medicalOrder.orderPrice).toFixed(2);
                this.medicalOrder.processingCosts = parseFloat(rdata.medicalOrder.processingCosts).toFixed(2);

                this.medicalOrder.docTotalPrice = parseFloat(this.medicalOrder.medicalCountPrice * 0.3 +
                    this.medicalOrder.docPrice + this.medicalOrder.adjustmentPrice).toFixed(2);
                if (this.medicalOrder.picUrl !== null && this.medicalOrder.picUrl !== "") {
                    this.medicalOrder.picUrl = baseConfig.tencentCosUrl + this.medicalOrder.picUrl;
                    this.fileLists.push({
                        url: this.medicalOrder.picUrl,
                    });
                }
                if (this.medicalOrder.orderMedicineList !== null && this.medicalOrder.orderMedicineList !== "") {
                    for (let m = 0; m < this.medicalOrder.orderMedicineList.length; m++) {
                        let melist = this.medicalOrder.orderMedicineList[m];
                        let meName = melist.meName;
                        if (meName !== null && meName !== undefined) {
                            meName = meName.replace('配方', '').replace('颗粒', '').replace('饮片', '');
                        }
                        melist.meName = meName;
                        let decoctWay = melist.decoctWay;
                        let decoctionName = "";
                        if (decoctWay === '0') {
                            decoctionName = '无';
                        } else if (decoctWay === '1') {
                            decoctionName = '打碎';
                        } else if (decoctWay === '2') {
                            decoctionName = '烊化';
                        } else if (decoctWay === '3') {
                            decoctionName = '生汁兑入';
                        } else if (decoctWay === '4') {
                            decoctionName = '后下';
                        } else if (decoctWay === '5') {
                            decoctionName = '冲服';
                        }
                        melist.decoctionId = decoctWay;
                        melist.decoctionName = decoctionName;
                    }

                }

                if (this.medicalOrder.orderMedicineFuList !== null && this.medicalOrder.orderMedicineFuList !== "") {
                    for (let n = 0; n < this.medicalOrder.orderMedicineFuList.length; n++) {
                        let meName = this.medicalOrder.orderMedicineFuList[n].meName;
                        if (meName !== null && meName !== undefined) {
                            meName = meName.replace('配方', '').replace('颗粒', '').replace('饮片', '').replace('辅药', '');
                        }
                        this.medicalOrder.orderMedicineFuList[n].meName = meName;
                    }
                }
                this.medicalCountPrice = parseFloat(parseFloat(this.medicalOrder.medicalCountPrice) + parseFloat(this.medicalOrder.fuCountPrice)).toFixed(2);

                this.showOrderMedicineFuList = "";
                if (this.medicalOrder.orderMedicineFuList !== null && this.medicalOrder.orderMedicineFuList !== "") {
                    this.medicalOrder.orderMedicineFuList.forEach((med) => {
                        let meName = med.meName;
                        if (meName !== null && meName !== undefined) {
                            meName = meName.replace('配方', '').replace('颗粒', '').replace('饮片', '');
                        }
                        med.meName = meName;
                        this.showOrderMedicineFuList += med.meName + "(" + med.countNum + "g),";
                    });
                    this.showOrderMedicineFuList = this.showOrderMedicineFuList.substring(0, this.showOrderMedicineFuList.length - 1);
                }

                this.doctorInfo = rdata.doctorInfo;
                if (rdata.userReceiveAddress !== null && rdata.userReceiveAddress !== "" &&
                    rdata.userReceiveAddress !== undefined) {
                    this.userReceiveAddress = rdata.userReceiveAddress;
                }
                this.patientInfo = rdata.patientInfo;

                if (this.patientInfo.sex === '0') {
                    this.patientInfo.avatarImg = this.tencentCosUrl + "/tcmmsPic/manImg.png";
                } else if (this.patientInfo.sex === '1') {
                    this.patientInfo.avatarImg = this.tencentCosUrl + "/tcmmsPic/womanImg.png";
                } else {
                    this.patientInfo.avatarImg = this.tencentCosUrl + "/tcmmsPic/profile.jpg";
                }
                if (this.medicalOrder.orderSource !== 'patient' && this.medicalOrder.orderSource !== 'patientRepeat') {
                    // this.getPayErCode(rdata.medicalOrder.payQrcode);
                }

                let freeCasePic = this.medicalOrder.freeCasePic;
                console.log(freeCasePic)
                if (freeCasePic !== null && freeCasePic !== "") {
                    let freeCasePicArray = freeCasePic.split(",");
                    if (freeCasePicArray.length > 0) {
                        this.freeCasePicArr = [];
                        for (let i = 0; i < freeCasePicArray.length; i++) {
                            let freeImgUrl = baseConfig.tencentCosUrl + freeCasePicArray[i];
                            console.log(freeImgUrl);
                            this.freeCasePicArr.push(freeImgUrl);
                        }

                    }
                }

            });

        },



        // 打开处方笺
        exportOrder() {
            this.prescriptionPaperDialogDialogVisible = true;
            this.printDate = this.getDayDateNow();
        },

        handlePrint(){
            // 获取要转换为图片的 DOM 元素
            const element = document.querySelector('.prescriptionPaperDialog');
            // 将 DOM 元素转换为 Canvas 对象
            html2canvas(element,{
                dpi: window.devicePixelRatio * 2,
                useCORS: true,
                allowTaint: true,
                async: true,
            }).then(canvas => {
                // 创建一个新的图片元素，并将 Canvas 对象作为背景图
                const img = new Image();
                img.src = canvas.toDataURL('image/png');
                img.style.width='100%'
                // 在 iframe 文档中添加图片元素
                const iframe = document.createElement('iframe');
                iframe.style.width='100%'
                iframe.classList.add('print-iframe')
                document.body.appendChild(iframe)
                const doc = iframe.contentWindow.document
                doc.body.appendChild(img);
                //避免图片没有加载完成就打印
                setTimeout(()=>{
                    iframe.contentWindow.print();
                },100)

            }, {
                useCORS: true,
                allowTaint: false,
                logging: false,
                letterRendering: true,
            })
        },


        // 获取当前时间
        getDayDateNow() {
            let nowDate = new Date();
            let year = nowDate.getFullYear();
            let month = this.checkTime(nowDate.getMonth() + 1);
            let date = this.checkTime(nowDate.getDate());
            let hour = this.checkTime(nowDate.getHours());
            let minute = this.checkTime(nowDate.getMinutes());
            let second = this.checkTime(nowDate.getSeconds());
            return year + "-" + month + "-" + date + " " + hour + ":" + minute + ":" + second;
        },

        checkTime(a) {
            if (a < 10) {
                a = "0" + a;
            }
            return a;
        },

    }
}
